import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';

const ClientFilters = ({ onFilterChange, activeFilters }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedSections, setExpandedSections] = useState({
    status: true,
    destination: true,
    payment: true
  });

  const filterCategories = {
    status: [
      { id: 'active', label: 'Ativos', count: 24 },
      { id: 'pending', label: 'Pendentes', count: 8 },
      { id: 'completed', label: 'Concluídos', count: 156 },
      { id: 'cancelled', label: 'Cancelados', count: 12 }
    ],
    destination: [
      { id: 'europe', label: 'Europa', count: 45 },
      { id: 'asia', label: 'Ásia', count: 32 },
      { id: 'americas', label: 'Américas', count: 28 },
      { id: 'africa', label: 'África', count: 15 },
      { id: 'oceania', label: 'Oceania', count: 12 }
    ],
    payment: [
      { id: 'paid', label: 'Pago Integralmente', count: 89 },
      { id: 'partial', label: 'Pagamento Parcial', count: 34 },
      { id: 'overdue', label: 'Atrasado', count: 12 },
      { id: 'pending', label: 'Aguardando Entrada', count: 18 }
    ]
  };

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev?.[section]
    }));
  };

  const handleSearchChange = (e) => {
    const value = e?.target?.value;
    setSearchTerm(value);
    onFilterChange({ ...activeFilters, search: value });
  };

  const handleFilterToggle = (category, filterId) => {
    const currentFilters = activeFilters?.[category] || [];
    const newFilters = currentFilters?.includes(filterId)
      ? currentFilters?.filter(id => id !== filterId)
      : [...currentFilters, filterId];
    
    onFilterChange({ ...activeFilters, [category]: newFilters });
  };

  const clearAllFilters = () => {
    setSearchTerm('');
    onFilterChange({ search: '', status: [], destination: [], payment: [] });
  };

  const activeFilterCount = 
    (activeFilters?.status?.length || 0) + 
    (activeFilters?.destination?.length || 0) + 
    (activeFilters?.payment?.length || 0);

  return (
    <div className="h-full flex flex-col bg-card border-r border-border">
      <div className="p-4 border-b border-border">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-foreground">Filtros</h2>
          {activeFilterCount > 0 && (
            <button
              onClick={clearAllFilters}
              className="text-xs text-primary hover:text-primary/80 transition-colors"
            >
              Limpar ({activeFilterCount})
            </button>
          )}
        </div>
        <Input
          type="search"
          placeholder="Buscar clientes..."
          value={searchTerm}
          onChange={handleSearchChange}
          className="w-full"
        />
      </div>
      <div className="flex-1 overflow-y-auto p-4 space-y-6">
        <div>
          <button
            onClick={() => toggleSection('status')}
            className="w-full flex items-center justify-between mb-3 text-sm font-medium text-foreground hover:text-primary transition-colors"
          >
            <span>Status do Cliente</span>
            <Icon 
              name={expandedSections?.status ? 'ChevronDown' : 'ChevronRight'} 
              size={16} 
            />
          </button>
          {expandedSections?.status && (
            <div className="space-y-2 pl-2">
              {filterCategories?.status?.map(filter => (
                <Checkbox
                  key={filter?.id}
                  label={
                    <div className="flex items-center justify-between w-full">
                      <span className="text-sm">{filter?.label}</span>
                      <span className="text-xs text-muted-foreground">{filter?.count}</span>
                    </div>
                  }
                  checked={activeFilters?.status?.includes(filter?.id) || false}
                  onChange={() => handleFilterToggle('status', filter?.id)}
                  size="sm"
                />
              ))}
            </div>
          )}
        </div>

        <div>
          <button
            onClick={() => toggleSection('destination')}
            className="w-full flex items-center justify-between mb-3 text-sm font-medium text-foreground hover:text-primary transition-colors"
          >
            <span>Destino</span>
            <Icon 
              name={expandedSections?.destination ? 'ChevronDown' : 'ChevronRight'} 
              size={16} 
            />
          </button>
          {expandedSections?.destination && (
            <div className="space-y-2 pl-2">
              {filterCategories?.destination?.map(filter => (
                <Checkbox
                  key={filter?.id}
                  label={
                    <div className="flex items-center justify-between w-full">
                      <span className="text-sm">{filter?.label}</span>
                      <span className="text-xs text-muted-foreground">{filter?.count}</span>
                    </div>
                  }
                  checked={activeFilters?.destination?.includes(filter?.id) || false}
                  onChange={() => handleFilterToggle('destination', filter?.id)}
                  size="sm"
                />
              ))}
            </div>
          )}
        </div>

        <div>
          <button
            onClick={() => toggleSection('payment')}
            className="w-full flex items-center justify-between mb-3 text-sm font-medium text-foreground hover:text-primary transition-colors"
          >
            <span>Status de Pagamento</span>
            <Icon 
              name={expandedSections?.payment ? 'ChevronDown' : 'ChevronRight'} 
              size={16} 
            />
          </button>
          {expandedSections?.payment && (
            <div className="space-y-2 pl-2">
              {filterCategories?.payment?.map(filter => (
                <Checkbox
                  key={filter?.id}
                  label={
                    <div className="flex items-center justify-between w-full">
                      <span className="text-sm">{filter?.label}</span>
                      <span className="text-xs text-muted-foreground">{filter?.count}</span>
                    </div>
                  }
                  checked={activeFilters?.payment?.includes(filter?.id) || false}
                  onChange={() => handleFilterToggle('payment', filter?.id)}
                  size="sm"
                />
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="p-4 border-t border-border">
        <div className="text-xs text-muted-foreground">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Users" size={14} />
            <span>Total de Clientes: 200</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Filter" size={14} />
            <span>Filtros Ativos: {activeFilterCount}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientFilters;